import { Component, NgModule, enableProdMode, OnInit, ViewChild, Input } from '@angular/core';
import { BasicCollege, University, EnrolmentFormService, CourseProduct, PostExamFormStudentAllot, PostExamFormStudent, PreExamFormStudent, PreStudentEnrolmentSubjectList, SubjectDetail, BasicSubject } from './../../services/enrolment-form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Tab, AdmissionService, directadmission, UsertDetailsStatus } from "../../services/admission.service";
import { HelperService } from '../../../shared/services/helper.service';
import { Configuration } from '../../../app.constants';
import {
  DxSelectBoxModule,
  DxTextAreaModule,
  DxDateBoxModule,
  DxFormModule
} from 'devextreme-angular';
import { formatDate } from '@angular/common';
import { DxFormComponent } from 'devextreme-angular';
import { CetadmissionService, CETadmission } from './../../services/cetadmission.service';
import { CourseselectionService, EntPreStudentCollegeList, PreStudentOtherInfo, EntPreStudentCourseCheckAlreadyPresent, ScheuldeData } from "../../services/courseselection.service";
import { PersonalinformationService, EnrolmentSubject, EnrolmentSubjectMain, personalinformation2, personalinformation, Occupations, MinorityDataList, PreviousCollegeList } from '../../services/personalinformation.service';
import { CasteService, BasicCaste, BasicSubCaste } from '../../../registration/services/Caste.service';
import { ReservationcategoryService, Reservationcategory } from '../../../registration/services/reservationcategory.service'
import { SocialreservationService, preSocialReservationInfo } from '../../services/socialreservation.service'
import { Socialreservation } from 'src/app/registration/services/socialreservation.service';


@Component({
  selector: 'enrolmentallotment-form',
  templateUrl: './enrolmentallotment-form.component.html',
  styleUrls: ['./enrolmentallotment-form.component.scss'],
  providers: [EnrolmentFormService,
    CasteService,
    ReservationcategoryService,
  ]
})
export class EnrolmentallotmentFormComponent implements OnInit {
  @ViewChild(DxFormComponent) myform: DxFormComponent;

  documentId: number;
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;
  errorMessage: string[] = new Array();
  preExamFormStudent: PreExamFormStudent;
  courseProducts: CourseProduct[];
  dataSource: any;
  PreStudentAllotmentID: number = 0;
  DocumentsList: any;
  showButtons: boolean = true;
  freshflag: string;
  subjectflag: string;
  obj: any;
  LanguageLabel: any;
  GroupList: any;
  loadIndicatorVisible: boolean = false;
  popupVisible3 = false;
  public RemoveFileData: any;
  public flag: any;
  fileDocUpload1: any;
  postExamFormStudent: PostExamFormStudentAllot = {
    PreStudentAllotmentID: 0,
    StudentID: 0,
    CourseID: 0,
    CourseName: "",
    CollegeID: 0,
    CoursePartID: 0,
    BranchID: 0,
    UniversityId: 0,
    UniversityID: 0,
    QuotaType: "",
    RoundNo: 0,
    ApplicationFormNo: "",
    ReservationCategoryID: 0,
    SpecialReservationCategoryID: 0,
    MinorityType: "",
    AllottedReservationCategoryID: 0,
    WeightagePoints: 0,
    Percentage: 0,
    EntranceExam: "",
    EntranceExamPercentile: 0,
    TotalPoints: 0,
    AllotmentDate: null,
    AllotmentDocumentPath: "",
    MinorityID: 0,
    BasicSubjectList: []
  };
  private sub: any;
  isdisable: boolean = true;
  isValid: boolean;
  RequestID: number;
  Fees: number;
  branchdatasource1: any;
  ScheduleList: any;
  PhyDisData: any;
  CasteData: any;
  CasteData1: BasicCaste[];
  SubCasteData: any;
  ResCatData: Reservationcategory[];
  categories: Reservationcategory[];
  StudentCastID: number;

  QuotaTypedata: any = [
    {
      "QuotaType": "M",
      "QuotaTypeName": "M"
    },
    {
      "QuotaType": "U",
      "QuotaTypeName": "U"
    },
    {
      "QuotaType": "O.S.",
      "QuotaTypeName": "O.S."
    },
    {
      "QuotaType": "ICAR",
      "QuotaTypeName": "ICAR"
    },
    {
      "QuotaType": "GOA",
      "QuotaTypeName": "GOA"
    },
    {
      "QuotaType": "Management",
      "QuotaTypeName": "Management"
    },
    {
      "QuotaType": "Diploma",
      "QuotaTypeName": "Diploma"
    },
  ]
  PreExamFormStudentData: any;
  PreExamFormStudentData1: PostExamFormStudentAllot;
  PreExamFormStudentData2: any;
  PreExamFormStudentData3: any;
  printdis: boolean = true;
  ExamFormPrintData: any;
  ExamFormPrint: any;
  StudentEnrollmentList: any;
  ISApprove: boolean;
  Savedisabled: boolean;
  paysource: any;
  paymentdis: boolean = true;
  paymentmsg: string = "";
  now: Date = new Date();
  payModeID: number;
  isExpired: boolean;
  isDD: boolean = true;
  SaveClick: boolean = false;
  count: number = 0;
  printrecdis: boolean = true;

  GroupListChild: any;
  MainSyllabusGroupID: number;
  GroupMaxItemMain: number;
  GroupMinimumItemMain: number;
  EnrolmentSubjectdata: any;
  BranchID: number = 0;
  branchdisable: boolean = false;
  prvmarkrequired: boolean = false;
  EnrolementBranchSelectionList: any;
  data: any;
  branchislection: boolean = false;
  CollegeData: any;
  universitydata: any;
  CollegeID: number;
  CourseID: number;
  UniversityId: number;
  CourseData: any;
  SubjectData: any;
  ReservationCategoryID: number;
  AllottedReservationCategoryID: number;
  castdisable: boolean = true;
  subcastedisable: boolean = true;
  othercastdisable: boolean = true;
  castname: string;
  category: string;
  SocialResData: Socialreservation;
  popupVisibleDoc: boolean = false;
  MinorityData: any;
  MinorityData1: MinorityDataList[];
  TempMinorityData: any;
  AllotmentDocumentPath: string = "";
  DocumentPresent: boolean = false;
  MathBioSubjectList: any;

  constructor(private EnrolmentFormService: EnrolmentFormService, private cetService: CetadmissionService,
    private ReservationcategoryService: ReservationcategoryService, private SocialreservationService: SocialreservationService, private CasteService: CasteService, private route: ActivatedRoute, private CourseselectionService: CourseselectionService, private AdmissionService: AdmissionService,
    private PersonalinformationService: PersonalinformationService, private router: Router, private helperService: HelperService, public configuration: Configuration) {
  }

  UpdateEvent(e) {
    if (e.newData.IsChecked == true) {
      this.count = this.count + 1;
    }
    if (e.newData.IsChecked == false) {
      if (this.count > 0) {
        this.count = this.count - 1;
      }
    }
  }

  ngOnInit() {debugger
    this.LanguageLabel = this.configuration.LanguageLabel[0];
    this.EnrolmentFormService.GetBasicCollegeList(0)
      .subscribe((data: BasicCollege) => {
        this.CollegeData = data;
      },
        error => {
          alert(error);
        },
        () => {

          this.EnrolmentFormService.GetBasicUniversityListByState(0)
            .subscribe((data: University[]) => this.universitydata = data,
              error => {
                alert(error);
              },
              () => {
                debugger
                this.SocialreservationService.GetSocialReservationInfo(this.configuration.StudentID)
                  .subscribe((data: preSocialReservationInfo[]) => this.data = data,
                    error => {
                      alert(error);
                    },
                    () => {debugger
                      this.SocialResData = this.data;
                      this.ReservationcategoryService.getAllReservationcategoryList()
                        .subscribe((data: Reservationcategory[]) => this.categories = data,
                          error => {
                            alert(error);
                          },
                          () => {debugger
                            this.PersonalinformationService.GetAllMinorityList()
                              .subscribe((data: MinorityDataList[]) => this.TempMinorityData = data,
                                error => {
                                  alert(error);
                                },
                                () => {debugger
                                  this.MinorityData = this.TempMinorityData;

                                  this.EnrolmentFormService.GetEligibleCourseForEnrolmentForAllotment(this.configuration.StudentID, this.configuration.ExamInstanceID, this.configuration.AcademicInstanceID)
                                    .subscribe((data: PostExamFormStudentAllot) => this.PreExamFormStudentData = data,
                                      error => {
                                        alert(error);
                                      },
                                      () => {

                                        if (this.PreExamFormStudentData.length == 0) {
                                          this.helperService.showWarningMessage("Data Not Found");
                                          this.router.navigate(['/dashboard']);
                                        } else {
                                          this.PreExamFormStudentData1 = this.PreExamFormStudentData[0];
                                          this.CollegeID = this.PreExamFormStudentData1.CollegeID;
                                          this.UniversityId = this.PreExamFormStudentData1.UniversityID;
                                          this.CourseID = this.PreExamFormStudentData1.CourseID;
                                          this.PreExamFormStudentData1.UniversityID = this.PreExamFormStudentData1.UniversityID;
                                          this.UniversityId = this.PreExamFormStudentData1.UniversityID;
                                          this.ReservationCategoryID = this.PreExamFormStudentData1.ReservationCategoryID;
                                          this.AllottedReservationCategoryID = this.PreExamFormStudentData1.AllottedReservationCategoryID;

                                          if (this.PreExamFormStudentData1.PreStudentAllotmentID > 0) {
                                          } else {
                                            this.PreExamFormStudentData1.AllotmentDate = formatDate(new Date(), 'dd/MMM/yyyy', 'en');
                                          }
                                          if (this.PreExamFormStudentData1.AllotmentDocumentPath == "" || this.PreExamFormStudentData1.AllotmentDocumentPath == undefined || this.PreExamFormStudentData1.AllotmentDocumentPath == null) {
                                          } else {
                                            this.DocumentPresent = true;
                                          }
                                          this.EnrolmentFormService.GetBasicCollegeCourseList(this.CollegeID)
                                            .subscribe((data: BasicCollege) => {
                                              this.CourseData = data;
                                            },
                                              error => {
                                                alert(error);
                                              },
                                              () => {
                                                if (this.CourseID > 0) {
                                                  this.EnrolmentFormService.GetMathBioSubjectForAllotment(this.CourseID, this.configuration.StudentID)
                                                    .subscribe((data: BasicSubject) => {
                                                      this.SubjectData = data;
                                                    },
                                                      error => {
                                                        alert(error);
                                                      },
                                                      () => {
                                                      });
                                                }
                                              });
                                        }
                                      });
                                });
                          });
                    });
              });
        });
  }
  cancelClick() {
    this.router.navigate(['/dashboard']);
  }
  viewPdfDocument(data, flag) {
    if (this.PreExamFormStudentData1.AllotmentDocumentPath.length > 0) {
      this.documentId = flag;
      this.urlDoc = this.PreExamFormStudentData1.AllotmentDocumentPath;
      this.openWindow();

    }
  }

  onCloseButton() {
    this.popupVisible3 = false;
  }
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };

  removeDocument(flag) {
    debugger
    //this.RemoveFileData =data;
    this.popupVisible3 = true;
    this.flag = flag;
  }

  RemoveFileconfirmOK() {
    debugger
    this.EnrolmentFormService.GetdeleteUploadedDocumentAllotment(this.PreExamFormStudentData1.PreStudentAllotmentID, this.configuration.StudentID)
      .subscribe((data: PostExamFormStudentAllot[]) => this.CasteData = data,
        error => {
          alert(error);
          this.popupVisible3 = false;
        },
        () => {
          this.popupVisible3 = false;
          this.configuration.EnrolmentFile = "";
          this.helperService.showSuccessMessage("File Deleted Successfully.");
        });
  }
  selectionChangedHandlerCategoryAlloted(e) {
    var AllottedReservationCategoryID = e.value;
    this.AllottedReservationCategoryID = e.value;
    if (AllottedReservationCategoryID == null || AllottedReservationCategoryID == undefined) {
      return;
    }
  }
  selectionChangedHandlerCategory(e) {
    var ReservationCategoryID = e.value;
    this.ReservationCategoryID = e.value;
    this.castdisable = false;
    if (ReservationCategoryID == null || ReservationCategoryID == undefined) {
      return;
    }

    this.subcastedisable = false;
    this.CasteService.getCasteByeReservationCategoryID(ReservationCategoryID)
      .subscribe((data: BasicCaste) => this.CasteData = data,
        error => {
          alert(error);
        },
        () => {

        });
  }
  selectionChangedHandlerCaste(e) {
    this.StudentCastID = e.value;
    this.othercastdisable = true;
    for (var i = 0; i < this.CasteData.length; i++) {
      if (this.CasteData[i].CasteID == e.value) {
        this.castname = this.CasteData[i].CasteDescription;

      }
    }
    if (this.castname == "Other") {
      this.othercastdisable = false;
    }
    var CasteID = e.value;
    this.subcastedisable = false;

  }
  saveRecord() {
    debugger;
    this.PreExamFormStudentData1.CollegeID = this.CollegeID;
    this.PreExamFormStudentData1.UniversityId = this.UniversityId;
    this.PreExamFormStudentData1.CourseID = this.CourseID;
    this.PreExamFormStudentData1.ReservationCategoryID = this.ReservationCategoryID
    this.PreExamFormStudentData1.AllottedReservationCategoryID = this.AllottedReservationCategoryID

    if (this.PreExamFormStudentData1.CollegeID == null || this.PreExamFormStudentData1.CollegeID == undefined || this.PreExamFormStudentData1.CollegeID == 0) {
      this.helperService.showWarningMessage("Select College");
      return;
    }
    if (this.PreExamFormStudentData1.CourseID == null || this.PreExamFormStudentData1.CourseID == undefined || this.PreExamFormStudentData1.CourseID == 0) {
      this.helperService.showWarningMessage("Select Program");
      return;
    }
    if (this.PreExamFormStudentData1.UniversityId == null || this.PreExamFormStudentData1.UniversityId == undefined || this.PreExamFormStudentData1.UniversityId == 0) {
      this.helperService.showWarningMessage("Select University");
      return;
    }
    this.PreExamFormStudentData1.UniversityID = this.PreExamFormStudentData1.UniversityId;
    if (this.PreExamFormStudentData1.AllotmentDate == null || this.PreExamFormStudentData1.AllotmentDate == undefined) {
      this.helperService.showWarningMessage("Select Allotment Date");
      return;
    }
    if (this.PreExamFormStudentData1.ApplicationFormNo == null || this.PreExamFormStudentData1.ApplicationFormNo == undefined || this.PreExamFormStudentData1.ApplicationFormNo == "") {
      this.helperService.showWarningMessage("Enter Application Form No");
      return;
    }
    if (this.DocumentPresent == true) {
      if (this.PreExamFormStudentData1.AllotmentDocumentPath == "" || this.PreExamFormStudentData1.AllotmentDocumentPath == undefined || this.PreExamFormStudentData1.AllotmentDocumentPath == null) {
        this.helperService.showWarningMessage("Please select Allotment Letter to be upload");
        return;
      } else {
      }
    }
    else if (this.configuration.EnrolmentFile == null || this.configuration.EnrolmentFile == "" || this.configuration.EnrolmentFile == undefined) {
      this.helperService.showWarningMessage("Please select Allotment Letter to be upload");
      return;
    }
    for (var i = 0; i < this.SubjectData.length; i++) {
      if (this.SubjectData[i].ObtMark > this.SubjectData[i].OutOfMark) {
        this.helperService.showWarningMessage("Obtained Marks Should be less than Out of Marks of " + this.SubjectData[i].SubjectName);
        return;
      }

    }
    this.Savedisabled = true;
    this.PreExamFormStudentData1.BasicSubjectList = this.SubjectData;
    if ((this.PreExamFormStudentData1.PreStudentAllotmentID == undefined)) { this.PreExamFormStudentData1.PreStudentAllotmentID = 0; }
    if (this.PreExamFormStudentData1.PreStudentAllotmentID == 0) {
      this.EnrolmentFormService.PostInsertPreStudentAllotment(this.PreExamFormStudentData1)
        .subscribe(value => {
          var PreStudentAllotmentID = value;
          this.uploadFile(PreStudentAllotmentID);
        },
          err => {
            this.helperService.showSuccessMessage("Not Saved.");
            this.Savedisabled = false;
          },
          () => {
          });
    }
    else {
      this.EnrolmentFormService.PostPreStudentAllotment(this.PreExamFormStudentData1)
        .subscribe(value => {
          this.SaveClick = true;
          this.Savedisabled = false;
          //this.helperService.showSuccessMessage("Allotment form Updated.");
          this.uploadFile(this.PreExamFormStudentData1.PreStudentAllotmentID);
        },
          err => {
            this.helperService.showSuccessMessage("Not Saved.");
            this.Savedisabled = false;
          },
          () => {
          });
    }

  }
  uploadFile(PreStudentAllotmentID) {
    debugger
    if (this.DocumentPresent == true) {
      if (this.configuration.EnrolmentFile == null || this.configuration.EnrolmentFile == undefined) {
        this.helperService.showSuccessMessage("Allotment form Saved.");
        this.router.navigate(['/dashboard']);
        return;
      } else {
      }
    }
    this.EnrolmentFormService.uploadEnrolmentFileAllotment(this.configuration.EnrolmentFile, this.configuration.StudentID, PreStudentAllotmentID).subscribe(
      data => {
      },
      err => {
        debugger;
      },
      () => {
        this.helperService.showSuccessMessage("Allotment form Saved.");
        this.router.navigate(['/dashboard']);
      })
  }
  selectionChangedHandlerUniversity(e) {
    debugger;
    this.UniversityId = e.value;
  }
  selectionChangedHandlerCollege(e) {
    debugger;
    this.CollegeID = e.value;
    if (this.CollegeID == 0 || this.CollegeID == null || this.CollegeID == undefined) {
      return;
    }
    this.EnrolmentFormService.GetBasicCollegeCourseList(this.CollegeID)
      .subscribe((data: BasicCollege) => {
        this.CourseData = data;
      },
        error => {
          alert(error);
        },
        () => {
          //this.CourseID = this.PreExamFormStudentData1.CourseID;
        });
  }
  selectionChangedHandlerCourse(e) {
    debugger;
    this.CourseID = e.value;
    if (this.CourseID == 0 || this.CourseID == null || this.CourseID == undefined) {
      return;
    }
    this.EnrolmentFormService.GetMathBioSubjectForAllotment(this.CourseID, this.configuration.StudentID)
      .subscribe((data: BasicSubject) => {
        this.SubjectData = data;
      },
        error => {
          alert(error);
        },
        () => {
        });
  }
  getdata() {

  }
}












